import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { CameraConfig, CameraSource, ConfigState } from "./config.types";

const initialState: ConfigState = {
    selectedCameraId: "",
    cameraSource: "app",
    cameraConfig: {
        exposure: true,
        focus: true,
        mode: "captureImage",
        quality: "4k",
    },
};

export const ConfigSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        // ----------------------- Camera ---------------------------
        setCameraSource: (state, { payload }: PayloadAction<CameraSource>) => {
            state.cameraSource = payload;
        },
        setSelectedCameraId: (state, { payload }: PayloadAction<string>) => {
            state.selectedCameraId = payload;
        },
        updateCameraConfig(
            state,
            action: PayloadAction<Partial<CameraConfig>>,
        ) {
            state.cameraConfig = {
                ...state.cameraConfig,
                ...action.payload,
            };
        },
    },
});

export const {
    // ---------------------------- Camera --------------
    setCameraSource,
    setSelectedCameraId,
    updateCameraConfig,
} = ConfigSlice.actions;

export const configReducer = ConfigSlice.reducer;
